import React, { useEffect, useState } from 'react';
export function FinalCTA() {
  const [timeLeft, setTimeLeft] = useState({
    d: 5,
    h: 19,
    m: 9,
    s: 0
  });
  const [selectedPack, setSelectedPack] = useState<1 | 2>(2);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          d,
          h,
          m,
          s
        } = prev;
        if (s > 0) s--;else {
          s = 59;
          if (m > 0) m--;else {
            m = 59;
            if (h > 0) h--;else {
              h = 23;
              if (d > 0) d--;
            }
          }
        }
        return {
          d,
          h,
          m,
          s
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const pad = (n: number) => n.toString().padStart(2, '0');
  const packUrls = {
    1: 'https://www.impulsodigitalstore.com/cart/43016137179213:1',
    2: 'https://www.impulsodigitalstore.com/cart/43016137965645:1'
  };
  const packLabels = {
    1: '→ QUIERO EL MEGAPACK — $19.990 ARS',
    2: '🔥 QUIERO EL MEGAPACK + QUEMA X2'
  };
  return <div className="bg-brand-deepInk py-18 px-6 text-center" data-id="element-138">
      <div className="max-w-[960px] mx-auto" data-id="element-139">
        <h2 className="font-display text-[26px] sm:text-[4vw] md:text-[44px] text-white mb-3 uppercase" data-id="element-140">
          El próximo lunes puede ser diferente
        </h2>
        <p className="text-[16px] text-brand-muted mb-7" data-id="element-141">
          Entrá al MegaPack Cuerpo Nuevo después de los 40 y empezá tu
          transformación hoy.
        </p>

        <p className="text-[12px] text-brand-red font-bold tracking-[1px] uppercase mb-2.5" data-id="element-142">
          ⚠️ Precio de lanzamiento — cierra en:
        </p>

        <div className="flex justify-center items-center gap-1.5 mb-6" data-id="element-143">
          <div className="bg-black text-brand-red font-display text-[36px] font-bold py-2.5 px-4 rounded-lg min-w-[64px] text-center border-2 border-brand-red/30 leading-none" data-id="element-144">
            {pad(timeLeft.d)}
          </div>
          <span className="text-[32px] font-bold text-brand-red leading-none" data-id="element-145">
            :
          </span>
          <div className="bg-black text-brand-red font-display text-[36px] font-bold py-2.5 px-4 rounded-lg min-w-[64px] text-center border-2 border-brand-red/30 leading-none" data-id="element-146">
            {pad(timeLeft.h)}
          </div>
          <span className="text-[32px] font-bold text-brand-red leading-none" data-id="element-147">
            :
          </span>
          <div className="bg-black text-brand-red font-display text-[36px] font-bold py-2.5 px-4 rounded-lg min-w-[64px] text-center border-2 border-brand-red/30 leading-none" data-id="element-148">
            {pad(timeLeft.m)}
          </div>
          <span className="text-[32px] font-bold text-brand-red leading-none" data-id="element-149">
            :
          </span>
          <div className="bg-black text-brand-red font-display text-[36px] font-bold py-2.5 px-4 rounded-lg min-w-[64px] text-center border-2 border-brand-red/30 leading-none" data-id="element-150">
            {pad(timeLeft.s)}
          </div>
        </div>

        <div className="flex flex-col gap-4 max-w-[600px] mx-auto mb-7 text-left" data-id="element-151">
          {/* Pack 1 */}
          <div onClick={() => setSelectedPack(1)} className={`bg-white/5 border rounded-xl py-5.5 px-5 cursor-pointer transition-colors flex items-center gap-4 ${selectedPack === 1 ? 'border-brand-green bg-brand-green/5 border-2' : 'border-brand-border'}`} data-id="element-152">
            <div className={`w-[22px] h-[22px] rounded-full border-2 flex items-center justify-center shrink-0 ${selectedPack === 1 ? 'border-brand-green' : 'border-brand-muted'}`} data-id="element-153">
              {selectedPack === 1 && <div className="w-3 h-3 rounded-full bg-brand-green" data-id="element-154"></div>}
            </div>

            <div className="flex-1" data-id="element-155">
              <span className="text-[20px] mb-1 block" data-id="element-156">📦</span>
              <p className="font-display text-base text-white mb-0.5 uppercase" data-id="element-157">
                MegaPack Cuerpo Nuevo después de los 40
              </p>
              <p className="text-[12px] text-brand-muted mb-1" data-id="element-158">
                6 Tomos + 6 Bonos
              </p>
              <p className="text-[12px] text-brand-green font-semibold" data-id="element-159">
                Ideal para: empezar la transformación desde hoy
              </p>
            </div>

            <div className="text-right shrink-0" data-id="element-160">
              <span className="text-[12px] text-brand-muted line-through block text-right" data-id="element-161">
                $51.000
              </span>
              <span className={`font-display text-[22px] font-bold whitespace-nowrap ${selectedPack === 1 ? 'text-brand-green' : 'text-white'}`} data-id="element-162">
                $19.990 ARS
              </span>
            </div>
          </div>

          {/* Pack 2 */}
          <div onClick={() => setSelectedPack(2)} className={`bg-white/5 border rounded-xl py-5.5 px-5 cursor-pointer transition-colors flex items-center gap-4 ${selectedPack === 2 ? 'border-brand-green bg-brand-green/5 border-2' : 'border-brand-border'}`} data-id="element-163">
            <div className={`w-[22px] h-[22px] rounded-full border-2 flex items-center justify-center shrink-0 ${selectedPack === 2 ? 'border-brand-green' : 'border-brand-muted'}`} data-id="element-164">
              {selectedPack === 2 && <div className="w-3 h-3 rounded-full bg-brand-green" data-id="element-165"></div>}
            </div>

            <div className="flex-1" data-id="element-166">
              <span className="text-[20px] mb-1 block" data-id="element-167">👑</span>
              <p className="font-display text-base text-white mb-0.5 uppercase" data-id="element-168">
                MegaPack + Quema x2
              </p>
              <p className="text-[12px] text-brand-muted mb-1" data-id="element-169">
                6 Tomos + 6 Bonos + Plan de 21 Días
              </p>
              <p className="text-[12px] text-brand-green font-semibold" data-id="element-170">
                ⭐ Ideal para: resultados acelerados con plan ya armado
              </p>
            </div>

            <div className="text-right shrink-0" data-id="element-171">
              <span className="text-[12px] text-brand-muted line-through block text-right" data-id="element-172">
                $69.000
              </span>
              <span className={`font-display text-[22px] font-bold whitespace-nowrap ${selectedPack === 2 ? 'text-brand-green' : 'text-white'}`} data-id="element-173">
                $27.990 ARS
              </span>
            </div>
          </div>
        </div>

        <a href={packUrls[selectedPack]} className="block w-full max-w-[600px] mx-auto bg-brand-green text-white font-display text-[17px] font-bold tracking-[1px] py-4 px-7 rounded-lg text-center uppercase border-none cursor-pointer transition-transform hover:-translate-y-0.5 mb-3 shadow-[0_0_20px_rgba(0,200,83,0.2)]" data-id="element-174">
          {packLabels[selectedPack]}
        </a>
      </div>
    </div>;
}